import { createRouter as createTanstackRouter } from "@tanstack/react-router";

import { buildConfigFromEnv } from "./app";
import { routeTree } from "./app/router/routeTree.gen";
import { NotFoundPage } from "./pages/not-found";

declare module "@tanstack/react-router" {
  // eslint-disable-next-line @typescript-eslint/consistent-type-definitions
  interface Register {
    router: ReturnType<typeof createRouter>;
  }
}

export function createRouter() {
  const config = buildConfigFromEnv();

  return createTanstackRouter({
    routeTree,
    scrollRestoration: true,
    context: {
      config,
    },
    defaultNotFoundComponent: NotFoundPage,
  });
}
